import React, { useState, useContext, useRef, useEffect } from "react";
import { FiMoreVertical } from 'react-icons/fi';
import DetachWorkspaceDialog from "./WorkspaceDialogs/DetachWorkspace";
import { HomeContext } from './Home'
import { useCheckDeleteWorkspaceMutation } from "../../Redux/Workspace/workspaceActionsSlice";
import { useEditDashboardMutation } from "../../Redux/Workspace/workspaceActionsSlice";
import { HomeWorkspaceTiles, Privacy } from "../../Types/HomePageInterface";
import { workspaceColors, colorClassMappings } from './HomeUtils'
import { FoundationsEnums } from "../../enum";
import { useSelector } from "react-redux";
import { getCurrentUserData, RootState } from "../../Redux/store";
import { FoundationsGenericToaster } from "../../GenericComponents/FoundationsGenericToaster";
import { checkType1 } from "../../GlobalMethods";
import { useWorkspaceStore } from "../Workspace/workspaceContext";
import { WorkspaceApiDTO_Workspace } from "../../Interfaces/APIContracts/WorkspaceApiDTO_Workspace";


// TO DO : USE COMMON DIALOG -- HARSH
// TO DO : Replace the document.getElementById when we have all dialogs in place


declare let window: any
const UnicornApp = window.unicornInstance as any
interface WorkspaceData {
    isShareWorkspace: boolean,
    isEditWorkspace: boolean
    isDeleteWorkpsace: boolean
    isDetachWorkspace: boolean
}
interface DropdownProps {
    id: number;
    dataToggleElType: string;
    dataLastUpdatedByUserId: string;
    dataPrivacy: string;
    dataCreatedByUserId: string;
    dataMenuType: string;
    dataShareType: string;
    dataToggleClass: string;
    dataToggleIconClass: string;
    dataWorkspaceId: number;
    dataCurrentColor: string;
    dataWsid: string;
    HomeWorkspaceTiles: HomeWorkspaceTiles;
    dataWorkspaceName: string;
    dataWorkspaceDescription: string
    dataWorkspacePrivacyLock: HomeWorkspaceTiles["Privacy"] | HomeWorkspaceTiles["PrivacyLock"];
    tileRef: any
}

const WorkspaceDropdown: React.FC<DropdownProps> = ({
    id,
    dataToggleElType,
    dataLastUpdatedByUserId,
    dataPrivacy,
    dataCreatedByUserId,
    dataMenuType,
    dataShareType,
    dataToggleClass,
    dataToggleIconClass,
    dataWorkspaceId,
    dataCurrentColor,
    dataWsid,
    HomeWorkspaceTiles,
    dataWorkspaceName,
    dataWorkspaceDescription,
    dataWorkspacePrivacyLock,
    tileRef
}) => {

    const workspaceColor = workspaceColors;

    const colorClassMapping = colorClassMappings;

    const [isMenuVisible, setMenuVisible] = useState(false);
    const [isColorPaletteVisible, setColorPaletteVisible] = useState(false);
    const [WorskSpaceColor, SetWorskSpaceColor] = useState<string>(workspaceColor.white)
    const workspaceRef = useRef<HTMLDivElement | null>(null);
    const dropDownVerticalDotsRef = useRef<HTMLDivElement | null>(null);
    const dropDownRef = useRef<HTMLUListElement | null>(null);

    const handleMouseEnter = () => setMenuVisible(true);
    const handleMouseLeave = () => setMenuVisible(false);
    const handleMouseEnterColorPalette = () => setColorPaletteVisible(true);
    const handleMouseLeaveColorPalette = () => setColorPaletteVisible(false);
    const [colorPalettePosition,setColorPalettePosition ] = useState<string>('');
    const [dropdownPosition, setDropdownPosition] = useState<{ [key: string]: string }>({});
    const [dropdownClass, setDropdownClass] = useState<string>('top');
    const [dropdownSideClass, setDropdownSideClass] = useState<string>('left'); 
    const [currentWorkspaceData, setCurrentWorkspaceData] = useState<any>(null)
    const [workspaceMenu, setWorkspaceMenu] = useState<WorkspaceData>();
    const context = useContext(HomeContext);
    const {
        DetachThisWorkspaceDialog,
        setDetachThisWorkspaceDialog,
        EditThisWorkspaceDialog,
        setEditThisWorkspaceDialog,
        ShareThisWorkspaceDialog,
        setShareThisWorkspaceDialog,
        DeleteThisWorkspaceDialog,
        setDeleteThisWorkspaceDialog,
        WorkspaceIdforDialog,
        setWorkspaceIdforDialog,
        DialogMsg,
        setDialogMsg,
        rgborname_color,
        setrgborname_color,
        WorkSpaceDetails,
        SetWorkSpaceDetails,
        editCallback,
        SeteditCallback,
        triggerPrivacyLock
    } = context || {}; // Safeguard if context is null   

    const currentUserData = useSelector(
        (state: RootState) => getCurrentUserData(state)
    )
    const [checkDeleteWorkspace] = useCheckDeleteWorkspaceMutation();
    const [editDashboard] = useEditDashboardMutation();

    const [DataPrivacy, setDataPrivacy] = useState<Privacy| number>(  HomeWorkspaceTiles.PrivacyLock ?? HomeWorkspaceTiles.Privacy);    
    useEffect(() => {
        setDataPrivacy(dataWorkspacePrivacyLock)
    }, [dataWorkspacePrivacyLock, triggerPrivacyLock])

    const [AllowDelete, setAllowDelete] = useState<boolean>(false)
    const HandleDetachThisWorkSpace = () => {
        setDetachThisWorkspaceDialog(true)
        setWorkspaceIdforDialog(id)
    }
const setupWorkspace = useWorkspaceStore((s) => s.setupWorkspace);
    const HandleDeleteThisWorkSpace = () => {
        const formData = new FormData();
        formData.append("dashBoardId", id.toString());

        checkDeleteWorkspace(formData)
            .unwrap()
            .then((response) => {
                if (response?.statusCode === 201) {
                    const resultData = response.data;
                    if (resultData) {
                        if (!resultData.allowDelete) {
                            const alertMessage = resultData.lockStatus < 2
                                ? "Cannot Delete - Workspace lock status changed."
                                : "Cannot Edit - Workspace lock status changed to high security.";
                            setDialogMsg(alertMessage);
                            setAllowDelete(false); // Ensure AllowDelete is set to false if not allowed
                        } else {
                            let message = `Are you sure you want to delete this workspace <strong>permanently</strong>?<br><br><strong>This operation cannot be undone.</strong>`;
                            if (resultData.deleteUserDashBoardsCount > 0) {
                                message += `<br><br>This workspace is used by <strong>${resultData.deleteUserDashBoardsCount} other users</strong>.`;
                            }
                            setDialogMsg(message);
                            setWorkspaceIdforDialog(id)
                            setAllowDelete(true); // Allow the delete if conditions are met
                        }
                    }
                } else if (response?.statusCode === "OperationNotAllowed") {
                    FoundationsGenericToaster("error", "Sorry, you do not have permission to complete this operation.");
                }
            })
            .catch((error) => {
                console.error("Error checking delete permissions", error);
            });

        setDeleteThisWorkspaceDialog(true)
        setWorkspaceIdforDialog(id)

    }
    const HandleShareThisWorkSpace = () => {
        setShareThisWorkspaceDialog(true)
        setWorkspaceIdforDialog(id)
    }
    const HandleEditThisWorkSpace = () => {
        SetWorkSpaceDetails(HomeWorkspaceTiles)
        setrgborname_color(dataCurrentColor)
        setEditThisWorkspaceDialog(true)
        setWorkspaceIdforDialog(id)
        // SeteditCallback(() => (EditedWorkspaceData: any) => {
        //     setCurrentWorkspaceData((prev: any) => ({
        //     ...prev, 
        //     WorkspaceId: EditedWorkspaceData.WorkspaceId,
        //     Name: EditedWorkspaceData.Name,
        //     Description: EditedWorkspaceData.Description,
        //     PrivacyLock: EditedWorkspaceData.PrivacyLock,
        //     }))

        //   });
    }
    useEffect(() => {
        setWorkspaceMenu({
            isDeleteWorkpsace: canDeleteWorkspace(),
            isDetachWorkspace: canDetachWorkspace(),
            isEditWorkspace: canEditWorkspace(),
            isShareWorkspace: isShareWorkspace(),
        });
    }, [currentWorkspaceData, currentUserData, DataPrivacy]);
    const canDeleteWorkspace = () => {
        if (currentUserData.privileges.includes('Workspace_Delete') && DataPrivacy === FoundationsEnums.PrivacyLock.OpenUnlocked) {
            return true;


        }
        return false;
    }
    const canDetachWorkspace = () => {

        if (
            currentUserData.privileges?.includes('Workspace_Detach') &&
            DataPrivacy === FoundationsEnums.PrivacyLock.OpenUnlocked
        ) {
            return true
        }
        return false


    }
    const isWorkspaceSharedWithAnotherNonAdminAndNonCreatorUser = () => {
        if (currentWorkspaceData?.ShareType === FoundationsEnums.DashBoardShareType.ByRole) {
            return false
        }
        if (currentUserData?.id !== currentWorkspaceData?.CreatedBy?.id) {
            return !checkType1(currentUserData) && !currentUserData?.privileges?.includes('CustomerAdmin')
        }
        return false
    }
    const isAdminUserProxyingAsANonAdminNonCreator = () => {
        const isAdminProxying =
            !checkType1(currentUserData) &&
            !currentUserData?.privileges?.includes('CustomerAdmin') &&
            currentWorkspaceData.CreatedBy?.id !== currentUserData?.id
        return isAdminProxying
    }
    const canEditWorkspace = () => {
        let result = false;
    
        if (isWorkspaceSharedWithAnotherNonAdminAndNonCreatorUser()) {
            // Check if the user has the 'Workspace_Edit' privilege and the privacy lock condition
            if (currentUserData.privileges?.includes('Workspace_Edit') && DataPrivacy !== FoundationsEnums.PrivacyLock.PrivateNotVisible) {
                result = true;
            }
        } else if (isAdminUserProxyingAsANonAdminNonCreator()) {
            // Check if the user is an admin proxying and the workspace privacy lock condition
            if (currentUserData.privileges?.includes('Workspace_Edit') && currentWorkspaceData?.PrivacyLock === FoundationsEnums.PrivacyLock.OpenUnlocked) {
                result = true;
            }
        } else {
            // Check if the user has the 'Workspace_Edit' privilege (default case)
            if (currentUserData.privileges?.includes('Workspace_Edit')) {
                result = true;
            }
        }
    
        return result;
    }
    
    const isShareWorkspace = ():boolean => {
        let result = false;
    
        if (isWorkspaceSharedWithAnotherNonAdminAndNonCreatorUser()) {
            // Check if the user has the 'Workspace_Share' privilege and the privacy lock condition
            if (currentUserData.privileges?.includes('Workspace_Share') && DataPrivacy !== FoundationsEnums.PrivacyLock.PrivateNotVisible) {
                result = true;
            }
        } else {
            // Check if the user has the 'Workspace_Share' privilege (default case)
            if (currentUserData.privileges?.includes('Workspace_Share')) {
                result = true;
            }
        }
    
        return result;
    }
    const HandleColorThisWorkspace = (color: string) => {
        const validColor = color as keyof typeof workspaceColor;
        const rgbColor = workspaceColor[validColor];
        const colorClass = colorClassMapping[validColor];

        // Ensure tileRef.current exists before accessing it
        if (tileRef && tileRef.current) {

            Object.values(colorClassMappings).forEach((color) => {
                tileRef.current.classList.remove(color);
            });

            // Update the style of the referenced tile
            tileRef.current.classList.add(colorClass);
            // Alternatively, update the class
            // tileRef.current.className = `workspace-tile ${selectedColorKey}`;
        } else {
            console.error("tileRef is not properly attached or initialized.");
        }

        if (workspaceRef.current) {
            const WorkspaceId = id;
            const workspaceName = workspaceRef.current.getAttribute("data-Workspace-Name");
            const workspaceDescription = workspaceRef.current.getAttribute("data-Workspace-Description");
            const privacyLock = workspaceRef.current.getAttribute("data-Workspace-PrivacyLock");

            // Create the payload with the extracted values
            const EditDashBoardPayload = {
                WorkspaceId: WorkspaceId,
                Name: workspaceName,
                Description: workspaceDescription,
                PrivacyLock: privacyLock,
                rgborname_color: rgbColor
            };
            editDashboard(EditDashBoardPayload).unwrap().then((response) => {
                try {
                    if (response.statusCode == 204 || 200) {
                        FoundationsGenericToaster("success", response.data.MessageResults[0].Message);
                    } else {
                        FoundationsGenericToaster("error", response.data.MessageResults[0].Message);
                    }
                } catch (error) {
                    console.warn(error)
                    FoundationsGenericToaster("error", "Something went wrong");
                }
            })
        }
    }

    // Stop event propagation when clicking on any dropdown item
    const handleItemClick = (e: React.MouseEvent) => {
        e.stopPropagation(); // Prevent click from bubbling up to parent (redirectToWorkspace)
    };

    // Adjust the position of the dropdown dynamically based on the tile position
    useEffect(() => {
        // const tileElement = document.getElementById(`test_workspaceaction_dropdown_${id}_el`);
        const tileElement = workspaceRef.current;
        // const dropdownToggle = document.getElementById(`test_workspaceaction_${id}_dropdown_toggle`);
        const dropdownToggle = dropDownVerticalDotsRef.current;
        // const menu = document.getElementById(`test_workspaceaction_${id}_dropdown_menu`);
        const menu = dropDownRef.current;
    
        if (tileElement && dropdownToggle && menu) {
            const tileRect = tileElement.getBoundingClientRect();
            const toggleRect = dropdownToggle.getBoundingClientRect();
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;
            let positionStyles: { [key: string]: string } = { bottom: '4px' };
            // Calculate dynamically based on viewport width
            const halfwayPoint = viewportWidth / 2;
            // Adjust dropdown positioning based on screen width and toggleRect position
            if (toggleRect.right + menu.offsetWidth > viewportWidth) {
                positionStyles.right = 'auto';
                positionStyles.left = `${toggleRect.left - menu.offsetWidth}px`; // Shift to the left if overflow
                setDropdownSideClass('left');
                setColorPalettePosition('left');
            } 
            // Use dynamic halfway point instead of hardcoded 900
            else if (toggleRect.right > halfwayPoint) {
                setDropdownSideClass('right');
                setColorPalettePosition('left');
            } 
            else {
                setDropdownSideClass('right'); // Default to right side
                setColorPalettePosition('right');
            }
            // Check if dropdown overflows bottom edge
            if (toggleRect.bottom + menu.offsetHeight > viewportHeight) {
                positionStyles.bottom = 'auto';
                positionStyles.top = `${toggleRect.top - menu.offsetHeight}px`; // Shift up if overflow
            }
            // Determine if the tile is in top or bottom half of the viewport
            if (tileRect.top < viewportHeight / 2) {
                setDropdownClass('top'); // Top row dropdown points downward
            } else {
                setDropdownClass('bottom_4'); // Bottom rows dropdown points upwards
            }
            setDropdownPosition(positionStyles);
        }
    }, [isMenuVisible, id]);
    
     // Adjust the position of the dropdown dynamically based on the tile position
    useEffect(() => {
       const workspace = {
        WorkspaceId: dataWorkspaceId,
        Name: dataWorkspaceName,
        Description: dataWorkspaceDescription,
        PrivacyLock: DataPrivacy,
       } as WorkspaceApiDTO_Workspace

       setupWorkspace(workspace);
        
    }, [isMenuVisible]);

    return (

        <div
            id={`test_workspaceaction_dropdown_${id}_el`}
            ref={workspaceRef}
            data-id={`test_workspaceaction${id}_dropdown`}
            data-toggle_el_type={dataToggleElType}
            data-lastupdatedbyuserid={dataLastUpdatedByUserId}
            data-privacy={dataPrivacy}
            data-createdbyuserid={dataCreatedByUserId}
            data-menutype={dataMenuType}
            data-sharetype={dataShareType}
            data-toggle_class={dataToggleClass}
            data-toggle_icon_class={dataToggleIconClass}
            data-workspaceid={dataWorkspaceId}
            data-currentcolor={dataCurrentColor}
            data-wsid={dataWsid}
            data-Workspace-Name={dataWorkspaceName}
            data-Workspace-Description={dataWorkspaceDescription}
            data-Workspace-PrivacyLock={dataWorkspacePrivacyLock}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >

            <div className="dropdown workspace-popup-container">
                <div id={`test_workspaceaction_${id}_dropdown_toggle`} ref={dropDownVerticalDotsRef} className="foundations-dropdown-toggle bi">
                    <FiMoreVertical />
                    {/* ⋮ */}
                </div>
                <div>
                    {isMenuVisible && (
                        <ul
                            id={`$test_workspaceaction_${id}_dropdown_menu`}
                            ref={dropDownRef}
                            className={`dropdown-menu workspace-popup ${dropdownClass} ${dropdownSideClass}`}
                            style={{ display: isMenuVisible ? 'block' : 'none', height: "auto" }}
                        >
                            {workspaceMenu?.isEditWorkspace ? (
                                <li id="dashboard_menu_showEditDashBoardDialog" className="dropdown-item cursor-pointer" onClick={(e) => {
                                    handleItemClick(e);  // Prevent redirect on click
                                    HandleEditThisWorkSpace();  // Handle Edit logic
                                    handleMouseLeave();  // Hide the menu after clicking    
                                }}>
                                    Edit this workspace
                                </li>
                            ) : (<li
                                id="dashboard_menu_showEditDashBoardDialog_disabled"
                                className="dropdown-item-disabled"
                                title="Security privilege is not assigned for this action."
                            >
                                Edit this workspace
                            </li>
                            )}
                            {workspaceMenu?.isDeleteWorkpsace ? (
                                <li id="dashboard_menu_showDeleteDashBoardDialog" className="dropdown-item cursor-pointer" onClick={(e) => {
                                    handleItemClick(e);  // Prevent redirect on click
                                    HandleDeleteThisWorkSpace();  // Handle Delete logic
                                    handleMouseLeave();
                                }}>
                                    Delete this workspace
                                </li>
                            ) : (
                                <li
                                    id="dashboard_menu_showDeleteDashBoardDialog_disabled"
                                    className="dropdown-item-disabled"
                                    title="Security privilege is not assigned for this action."
                                >
                                    Delete this workspace
                                </li>
                            )}
                            {workspaceMenu?.isDetachWorkspace ? (
                                <li id="dashboard_menu_showDetachDashBoardDialog" className="dropdown-item cursor-pointer" onClick={(e) => {
                                    handleItemClick(e);  // Prevent redirect on click
                                    HandleDetachThisWorkSpace();  // Handle Detach logic
                                    handleMouseLeave();
                                }}>
                                    Detach this workspace

                                </li>
                            ) : (
                                <li
                                    id="dashboard_menu_showDetachDashBoardDialog_disabled"
                                    className="dropdown-item-disabled"
                                    title="Security privilege is not assigned for this action."
                                >
                                    Detach this workspace
                                </li>
                            )}
                            {workspaceMenu?.isShareWorkspace ? (
                                <li id="dashboard_menu_showShareDashBoardDialog" className="dropdown-item cursor-pointer" onClick={(e) => {
                                    handleItemClick(e);  // Prevent redirect on click
                                    HandleShareThisWorkSpace();  // Handle Share logic
                                    handleMouseLeave();
                                }}>
                                    Share this workspace
                                </li>
                            ) : (
                                <li
                                    id="dashboard_menu_showShareDashBoardDialog_disabled"
                                    className="dropdown-item-disabled"
                                    title="Security privilege is not assigned for this action."
                                >
                                    Share this workspace
                                </li>
                              )}
                              {workspaceMenu?.isEditWorkspace ? (
                            <li className="colorWorkspace cursor-pointer" onMouseEnter={handleMouseEnterColorPalette} onMouseLeave={handleMouseLeaveColorPalette} onClick={(e) => {
                                handleItemClick(e);  // Prevent redirect on click
                            }}>
                                Color This Workspace
                            </li>
                            ) :(null)}
                            {isColorPaletteVisible ? (
                                <div
                                    className={`color_palette_container ${colorPalettePosition}`}
                                    style={{ opacity: isColorPaletteVisible ? 1 : 0, display: isColorPaletteVisible ? "block" : "none" }}
                                    onMouseEnter={handleMouseEnterColorPalette} onMouseLeave={handleMouseLeaveColorPalette}
                                >
                                    <div className="color_palette">
                                        {Object.keys(workspaceColor).map((colorKey) => (
                                            <div
                                                key={colorKey}
                                                className={`chooseWorkspaceColor ${colorKey}-workspace`}
                                                data-name={colorKey}
                                                onClick={(e) => {
                                                    handleItemClick(e); // Stop event propagation
                                                    const selectedColorKey = e.currentTarget.getAttribute("data-name") || "";
                                                    HandleColorThisWorkspace(selectedColorKey); // Call your function
                                                }}// Pass the color key here
                                            >
                                                {/* Empty div, styled for color */}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : null}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
};

export default WorkspaceDropdown;
